module.exports = __webpack_public_path__ + "static/media/copy.svg";